export const tags = {
  system: {
    badge: 'System',
  },
} as const
